export class EnvironmentHelper {
  static isProduction() {
    return window.location.hostname.match(/^nar\.unidas\.com\.br/) !== null;
  }
}

export default EnvironmentHelper;
